export const DefPriority = -1;
export const PriorityIntroMap = {
    0: '高优',
    1: '普通',
    2: '低优',
};
